import TypeaheadContainer from "../../Componant/FormWidgets/Typeahead";

const Typeahead = () => {
  return (
    <div className="page-body">
      <TypeaheadContainer />
    </div>
  );
};

export default Typeahead;
